module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Nomination/nomination-sanction/nomination-sanction-grid/nomination-sanction-grid.component.css
// module id = ./src/app/hrms/Nomination/nomination-sanction/nomination-sanction-grid/nomination-sanction-grid.component.css
// module chunks = main